import { useReducer, useState } from 'react';
import { ACTIONS, reducer } from './reducer';
import { prepareState } from './utils';
import { ConsentStorage } from '../ConsentStorage';
export const useConsents = () => {
    const [initialStorage] = useState(ConsentStorage.getStorage());
    const [state, dispatch] = useReducer(reducer, initialStorage, prepareState);
    const toggleProvider = (provider, value) => {
        if (value) {
            dispatch({ provider, type: ACTIONS.PROVIDER_ON });
        }
        else {
            dispatch({ provider, type: ACTIONS.PROVIDER_OFF });
        }
    };
    const toggleAllowAll = (value) => {
        if (value) {
            dispatch({ type: ACTIONS.ALLOW_ALL });
        }
        else {
            dispatch({ type: ACTIONS.DISALLOW_ALL });
        }
    };
    return {
        allowAll: state.allowAll,
        providers: state.providers,
        toggleAllowAll,
        toggleProvider,
    };
};
//# sourceMappingURL=index.js.map